//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class WarehouseService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[Warehouse.Create]
	async create(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/store/warehouse/create', params || { });
	};

	//GeneratorFlag:[Warehouse.Delete]
	async delete(warehouseId, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		const params = {
			id:warehouseId
		}
	
		return await _server.delete('/store/warehouse/delete', {'params':params})
	};

	//GeneratorFlag:[Warehouse.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/store/warehouse/detail', {'params':params});
	};

	//GeneratorFlag:[Warehouse.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/store/warehouse/list', {'params':params});
	};

	//GeneratorFlag:[Warehouse.Update]
	async update(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/store/warehouse/update', params || { });
	};

//GeneratorFlag:[NewAction]
}